import React from 'react'

interface TopicsIconProps {
  size?: number
  className?: string
}

export const TopicsIcon: React.FC<TopicsIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M14.67 11.77L8.55 14.54C8.38 14.62 8.19 14.66 8 14.66C7.81 14.66 7.62 14.62 7.45 14.54L1.33 11.77M14.67 8.43L8.55 11.21C8.38 11.29 8.19 11.33 8 11.33C7.81 11.33 7.62 11.29 7.45 11.21L1.33 8.43M8.55 1.45C8.38 1.37 8.19 1.33 8 1.33C7.81 1.33 7.62 1.37 7.45 1.45L1.73 4.05C1.62 4.11 1.51 4.19 1.44 4.3C1.37 4.41 1.34 4.53 1.34 4.66C1.34 4.79 1.37 4.92 1.44 5.03C1.51 5.14 1.62 5.22 1.73 5.27L7.45 7.88C7.63 7.96 7.82 8 8.01 8C8.2 8 8.39 7.96 8.56 7.88L14.28 5.28C14.4 5.23 14.5 5.14 14.57 5.03C14.64 4.93 14.68 4.8 14.68 4.67C14.68 4.54 14.64 4.41 14.57 4.31C14.5 4.2 14.4 4.11 14.28 4.06L8.55 1.45Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
